export default "<app-create-submission [isEditing]=\"true\" [includeLoggedUser]=\"false\"></app-create-submission>\n";